import * as firebase from 'firebase';

const prodConfig = {
  apiKey: "AIzaSyBfFTdhikiG9KfhQdlTS1UrW1-wbaX4iUw",
  authDomain: "upperclassdates-production.firebaseapp.com",
  databaseURL: "https://upperclassdates-production.firebaseio.com",
  projectId: "upperclassdates-production",
  storageBucket: "upperclassdates-production.appspot.com",
  messagingSenderId: "75478734992"
};

const devConfig = {
  apiKey: "AIzaSyB2hqUd62k5YehA3eNVGFWQtVlZ3hh-NMw",
  authDomain: "ucd-chat.firebaseapp.com",
  databaseURL: "https://ucd-chat.firebaseio.com",
  projectId: "ucd-chat",
  storageBucket: "ucd-chat.appspot.com",
  messagingSenderId: "514009031854",
};
const config = process.env.REACT_APP_ENV === 'production'
  ? prodConfig
  : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}
const db = firebase.database();
const auth = firebase.auth();
const storage = firebase.storage();

export {
  db,
  auth,
  storage,
};


// WEBPACK FOOTER //
// ./src/firebase/firebase.js